/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export enum Role {
  EXTERNAL = 'EXTERNAL',
  USER = 'USER',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  ETMF_SITE_USER = 'ETMF_SITE_USER',
  ETMF_STUDY_USER = 'ETMF_STUDY_USER'
}

export const UserRole = Role // For backward compatibility

export const USER_ROLE = {
  ADMIN: 'ADMIN',
  CONTENT_ADMIN: 'CONTENT_ADMIN',
  POWER_USER: 'POWER_USER',
  USER: 'USER',
  AUDITOR: 'AUDITOR',
  INSPECTOR: 'INSPECTOR',
  EXTERNAL: 'EXTERNAL',
  CLOUD_ADMIN_ROLE: 'CLOUD_ADMIN_ROLE',
  RCR_USER: 'RCR_USER',
  ETMF_MANAGER: 'ETMF_MANAGER',
  ETMF_SPECIALIST: 'ETMF_SPECIALIST',
  ETMF_SITE_USER: 'ETMF_SITE_USER',
  ETMF_STUDY_USER: 'ETMF_STUDY_USER',
  ETMF_SPONSOR: 'ETMF_SPONSOR'
}
